import { Routes } from '@angular/router';
import { GolfEventListComponent } from './components/golf-event-list/golf-event-list.component';
import { LeagueComponent } from './components/league/league.component';

export const routes: Routes = [
    { path: '', redirectTo: 'events', pathMatch:'full' },
    { path: 'events', component: GolfEventListComponent  },
    { path: 'league/:id', component: LeagueComponent  },
];
